import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useActivityLogModel} from "@/stores/models/activity-log-list-model";

export const useActivityLogListStore  = defineStore(
    'activityLogListStore',
    () => {
       
        const isLoading = ref(false);
        const selectedPegawai = ref(null);
        const dataSourceActivityLogList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useActivityLogModel().activityLogCustomStore,
                filter: null,
            })
        );

        // const dataSourcePendidikanList = (additionalParams = null) => {
        //     // console.log('masuk dataSourcePendidikanList', additionalParams)
        //     return new DataSource({
        //       requireTotalCount: true,
        //       load: (loadOptions) => {
        //         // Handle load options and additionalParams separately
        //         return usePendidikanListModel().pendidikanListCustomStore.load([loadOptions, additionalParams]);
        //       }
        //     });
        // };

         const getData = async (filter, sort=null) => {
            useActivityLogModel().setFilter(filter);
            useActivityLogModel().setSort(sort);
            useActivityLogModel().setTake('all');
                await  dataSourceActivityLogList.value.reload();
                return {
                data: dataSourceActivityLogList.value._items,
                totalCount: dataSourceActivityLogList.value._items.length,
                // summary: [totalBiaya]
            };
            //  return dataSourceDiklatList.value._items;
        }

        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceActivityLogList.value.reload();
        };

        const initialized = ()=>{     
            useActivityLogModel().setFilter(null);
            dataSourceActivityLogList.value.reload();
        };

        return {
            dataSourceActivityLogList,
            isLoading,
            onMuatButtonClick,
            initialized,
            state,
            selectedPegawai,
            getData

        }
    }
);